module.exports = __webpack_public_path__ + "static/the_fish1-b5ff71055160c1d0903d902c884ff7f4.webm";